/* eslint-disable semi */
import { createDecorator } from 'vue-class-component';
import * as utils from './utils';
import DecoratorConfigs from './DecoratorConfigs';

const debug = process.env.NODE_ENV === 'development';

const DECORATOR_NAME = 'ExposeForm';

/**
 * コンポーネントが保持するElFormのインターフェースを
 * コンポーネント自身のインターフェースとして公開します
 *
 * 下記のパラメータを指定できます。
 * ref: フォームのref名を指定します。
 */
export default function ExposeForm (...args) {
  if (utils.isDecoratorCall(args)) {
    createAppDecorator()(...args);
  } else {
    return createAppDecorator(...args);
  }
}

function createAppDecorator (decoratorOptions = {}) {
  // 設定値のマージ
  decoratorOptions = DecoratorConfigs.marge(DECORATOR_NAME, decoratorOptions);

  // 実装時の整合性チェック
  if (debug) {
    utils.validateDecoratorOptions(
      DECORATOR_NAME, {
        ref: { type: 'string', mustBe: ['not empty'] }
      },
      decoratorOptions
    );
  }

  return createDecorator((options, key) => {
    // 実装時の整合性チェック
    if (debug) {
      console.debug(`${DECORATOR_NAME}: @ ${key}`);

      if (key !== 'data') {
        throw new Error(`${DECORATOR_NAME}: can decorate only data().`);
      }
    }

    // オプション値取得
    const ref = decoratorOptions.ref || 'form';

    // created時の処理を追加
    const created = options.created || function () { };
    options.created = utils.injectBefore(created, function () {
      ['validate', 'validateField', 'resetFields', 'clearValidate'].forEach(
        method => {
          if (debug && method in this) {
            console.error(
              `${DECORATOR_NAME}: Don't declare ${method} in this component.`
            );
          }
          this[method] = (...args) => {
            return this.$refs[ref][method](...args);
          };
        }
      );
    });
  });
}



// WEBPACK FOOTER //
// ./src/core/decorators/ExposeForm.js